// RETRIEVE LIMITS constants

export const INFO_MODAL = `info-modal`;
export const INPUT_MODAL = `input-modal`;
export const CONFIRM_MODAL_UPDATE_LIMIT = `confirm-modal-update`;
export const CONFIRM_MODAL_SKIP_RESTORE = `confirm-modal-skip`;
export const LIMITS_TEMPLATE = `lmits-content`;
export const LOADING = `pending`;
export const RETRIEVE_LIMITS_URL = `/player/limit/restoreDepositLimit`;

export const textKeysRetrieveLimits = [
	'SYSTEM_ERROR_GENERAL',
	'RETRIEVE_LIMITS_UPDATE_SUCCESS',
	'RETRIEVE_LIMITS_CONTINUE',
	'RETRIEVE_LIMITS_CANCEL',
	'RETRIEVE_LIMITS_ACCEPT',
	'RETRIEVE_LIMITS_INFO_TITLE',
	'RETRIEVE_LIMITS_INFO_CONTENT',
	'RETRIEVE_LIMITS_INPUT_TITLE',
	'RETRIEVE_LIMITS_INPUT_CONTENT',
	'RETRIEVE_LIMITS_CONFIRM_TITLE',
	'RETRIEVE_LIMITS_CONFIRM_UPDATE',
	'RETRIEVE_LIMITS_CONFIRM_SKIP',
	'RETRIEVE_LIMITS_TEMPLATE_TITLE',
	'RETRIEVE_LIMITS_TEMPLATE_INFO',
	'RETRIEVE_LIMITS_TEMPLATE_CUTOFF_TITLE',
	'RETRIEVE_LIMITS_TEMPLATE_CUTOFF_INFO',
	'RETRIEVE_LIMITS_TEMPLATE_RESTORE_CONFIRM',
	'RETRIEVE_LIMITS_TEMPLATE_SKIP_RESTORE',
	'RETRIEVE_LIMITS_TEMPLATE_CHOOSE_AMOUNT'
];

// DEPOSIT LIMITS constants
export const DL_TEMPLATE = `deposit-limits-content`;
export const DL_HEADER = `deposit-limits-header`;
export const DL_RG_VIEW = `responsible-gaming-view`;
export const DL_MAX_INPUT = 999999;
export const DL_TYPE_DAY = 'day';
export const DL_TYPE_WEEK = 'week';
export const DL_TYPE_MONTH = 'month';
export const WE_CARE_POPUP = `we-care-popup`;
export const DL_SCHUFA_POPUP = 'deposit-limit-schufa-popup';
export const LUGAS_LIMIT_POPUP = 'lugas-limit-popup';

export const textKeysDepositLimits = [
	'SYSTEM_ERROR_GENERAL',
	'MOBILE_DEPOSIT_LIMITS_FOOTER_INFO',
	'DEPOSIT_LIMITS_FOOTER_ADDITIONAL_INFO',
	'DEPOSIT_LIMITS_TEMPLATE_TITLE',
	'DEPOSIT_LIMITS_TEMPLATE_INFO',
	'MOBILE_DEPOSIT_LIMITS_CONFIRM',
	'MOBILE_RESPONSIBLE_GAMING_LEARN_MORE',
	'MOBILE_RESPONSIBLE_GAMING_DEPOSIT_LIMITS',
	'MOBILE_RESPONSIBLE_DAILY_LIMIT',
	'MOBILE_RESPONSIBLE_WEEKLY_LIMIT',
	'MOBILE_RESPONSIBLE_MONTHLY_LIMIT',
	'MOBILE_RESPONSIBLE_WE_CARE_HEADER',
	'MOBILE_RESPONSIBLE_WE_CARE_INFO',
	'MOBILE_RESPONSIBLE_WE_CARE_CONTINUE_TEXT',
	'MOBILE_RESPONSIBLE_WE_CARE_BACK_TEXT',
	'MOBILE_RESPONSIBLE_DEPOSIT_LIMIT_EDIT_TEXT',
	'MOBILE_RESPONSIBLE_SET_DAILY_LIMIT',
	'MOBILE_RESPONSIBLE_SET_WEEKLY_LIMIT',
	'MOBILE_RESPONSIBLE_SET_MONTHLY_LIMIT',
	'HEADER_RESPONSIBLE_RESPONSIBLE',
	'MOBILE_RESPONSIBLE_GAMING_SUPPORT_TITLE',
	'MOBILE_RESPONSIBLE_DEPOSIT_LIMIT_AMOUNT_EXCEEDS',
	'LUGAS_LIMIT_POPUP_TITLE',
	'LUGAS_LIMIT_POPUP_SUBTITLE',
	'SYNC_LIMIT',
	'SET_NEW_LIMIT',
	'LUGAS_SYNC_SUCCESS',
	'DEPOSIT_MANUAL_SUCCESS'
];

export const textKeysScfufapopup = [
	'MOBILE_RESPONSIBLE_DEPOSIT_LIMIT_SCHUFA_HEADER',
	'MOBILE_RESPONSIBLE_DEPOSIT_LIMIT_SCHUFA_INFO',
	'MOBILE_RESPONSIBLE_DEPOSIT_LIMIT_SCHUFA_CONTINUE_TEXT',
	'MOBILE_RESPONSIBLE_DEPOSIT_LIMIT_SCHUFA_BACK_TEXT',
	'SCHUFA_DEPOSIT_LIMIT_ERROR',
	'SCHUFA_API_ERROR'
];

enum LimitTypes {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY'
}

export type LimitTimeConstType = typeof LimitTypes.DAILY | typeof LimitTypes.MONTHLY | typeof LimitTypes.WEEKLY;

export const LIMIT_TIME_CONST_MAP: { [key: number]: LimitTimeConstType } = {
	5: LimitTypes.DAILY,
	6: LimitTypes.WEEKLY,
	7: LimitTypes.MONTHLY
};

export const ScenarioFlow = {
	REGISTRATION_FLOW: 'RegistrationFlow',
	RG_LIMITS_FLOW: 'RGLimitsFlow',
	DEPOSIT_FLOW: 'DepositFlow',
	QD_DEPOSIT_FLOW: 'QDDepositFlow'
};
